// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    INotificationItem,
    INotificationGroupItem,
    INotificationPayloadItem,
}                               from '../interfaces';

const getNotifications = async ({
    test,
}: {
    test: boolean,
}): Promise<INotificationPayloadItem> => {
    const functions = getFunctions();
    const handleGetNotifications = httpsCallable<
        Record<
            string,
            boolean
        >,
        {
            notifications: INotificationItem[],
            groups: { [k: string]: INotificationGroupItem },
        }
    >(
        functions,
        'getNotifications',
    );
    return handleGetNotifications({
        test,
    }).then((result) => {
        const payload = result.data;
        return {
            notifications: payload.notifications,
            groups: new Map(Object.entries(result.data.groups)),
        } as INotificationPayloadItem;
    }).catch((err) => {
        throw err;
    });
};

export default getNotifications;
